import * as React from 'react';
import { useState } from 'react';
import { Col, Row, Form, Nav, Card, Button, ListGroup, Badge, Alert, Modal, Spinner } from "react-bootstrap";
import * as yup from 'yup';
import * as formik from 'formik';
import vindrApi from "../utils/vindrapi";
import schemas from "../data/dataSchemas";


const { Formik } = formik;

class DialogSetMain extends React.Component {

	constructor(props) {
		super(props);
		
		this.state = {
			validated: false,
			status: {sent:null, message:''}
		}
		
		//this.owner = schemas.owner.cast(this.props.owner);
		
	}
	updateStatus(s){
		var x = {...this.state};
		x.status = s;
		this.setState(x);
		this.forceUpdate();
	}


	handleClose(data){
		this.props.onClose(data);
		this.updateStatus({sent:null, message:''});
	};
	handleOnShow(e){
		this.forceUpdate();
	};

	handleSubmit(data){

		
		this.updateStatus({sent:false, success:false, message:'Setting main scenario...'});
		//saveguard for testing

		var data = {...data,
			username: this.props.setup.user.userDetails,
			log:data.message
		}
		
		const projectId = this.props.setup.scenario.projectid;
		const scenarioId = this.props.setup.scenario.scenario_id ?? this.props.setup.scenario.scenarioid;
		
		//console.log(setMainScenario);
		vindrApi.setMainScenario(projectId, scenarioId, data).then((response)=>{
			//console.log(response);

				if(!response.success)
					this.updateStatus({sent:true, success:false, message:'Error setting main scenario'});
				else {
					this.updateStatus({sent:true, success:true, message:'Main scenario set.'});
					//redirect without timout
					setTimeout(() => {
						window.location.href = '/pages/project/'+projectId;
					}, 2000);	
				}


			
		}).catch((e)=>{
			this.updateStatus({sent:true, success:false, message:'Error setting main scenario'});
		});
		//this.updateStatus({sent:false, success:false, message:'Saving...'});
		
	};


	render() {
		return (
			<Modal show={this.props.setup.open} onHide={(e)=>this.handleClose(e)} onShow={(e)=>this.handleOnShow(e)} centered>
				<Modal.Header closeButton>
					<Modal.Title>Set main scenario</Modal.Title>
				</Modal.Header>

				<Formik validationSchema={schemas.setmain} onSubmit={this.handleSubmit.bind(this)} initialValues={{}}>	
					{({ handleSubmit, handleChange, values, touched, errors }) => (
						<Form noValidate onSubmit={handleSubmit}>
							{this.state.status.sent === null ? (
								<React.Fragment>
									<Modal.Body>
										<Row className="px-3">
											<Form.Group as={Col} md="12" controlId="validationFormik00">
												<Form.Label>Log message</Form.Label>
												<Form.Control as="textarea" name="message" onChange={handleChange} placeholder="...the reason to make this change" isValid={touched.message && !errors.message} isInvalid={touched.message && errors.message}/>
											</Form.Group>
											
											<div className="text-danger pt-2">
												{errors.message}
											</div>
										</Row>
										
									</Modal.Body>
									<Modal.Footer>
										<Button className="me-auto" variant="secondary" onClick={(e)=>this.handleClose()}>Close</Button>
										<Button variant="success" type="submit">Set Main</Button>
									</Modal.Footer>
								</React.Fragment>
							) : (
							<Modal.Body>
								<Row className="mb-3 dialog-feedback">
									<Col xs="12" className="dialog-feedback-icon text-center">
										{
										this.state.status.sent ?
											(this.state.status.success ? 
												(<i className="ri-checkbox-circle-line text-success"></i>)
												:
												(<i className="ri-error-warning-line text-warning"></i>)
											)
											:
											(<Spinner animation="border" variant="info" className="mt-5" />)
										}
									</Col>
									<Col xs="12" className="dialog-feedback-text mb-5">
										{this.state.status.message}
									</Col>
								</Row>
							</Modal.Body>	
							)}
						</Form>
					)}	
				</Formik>
			</Modal>
		);
	}
}

export default DialogSetMain;